import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Grid,
  Input,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { parseResume } from "./productsSlice";

const DummyForm = () => {
  const dispatch = useDispatch();
  const { loading, resumeData, error } = useSelector((state) => state.products);

  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);
  const fileInputRef = useRef(null);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (file) {
      dispatch(parseResume(file));
    }
  };
  useEffect(() => {
    if (resumeData) {
      setData([resumeData]);
    } else {
      setData([]);
    }
  }, [resumeData]);
  const handleReset = () => {
    setData([]);
    setFile(null); // Reset file state
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear file input
    }
  };
  return (
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Input
              type="file"
              onChange={handleFileChange}
              inputRef={fileInputRef}
            />
            <Button
              onClick={handleUpload}
              variant="contained"
              color="primary"
              disabled={loading}
              sx={{ mt: 2 }}
            >
              {loading ? "Uploading..." : "Upload Resume"}
            </Button>
            <Button
              onClick={handleReset}
              variant="contained"
              color="error"
              sx={{ mt: 2 }}
            >
              Reset
            </Button>
            {/* {resumeData && (
              <Typography color="success.main" mt={1}>
                Resume parsed successfully!
              </Typography>
            )} */}
            {error && (
              <Typography color="error.main" mt={1}>
                Error: {error}
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Box mt={4}>
            <Typography variant="h4" align="center" gutterBottom>
              Candidate Information
            </Typography>
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>Field</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Details
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.length > 0 &&
                    data?.map((candidate, index) => (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>{candidate?.name}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Email</TableCell>
                          <TableCell>{candidate.email}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Mobile</TableCell>
                          <TableCell>{candidate.mobile}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Job Title</TableCell>
                          <TableCell>{candidate.jobTitle}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Candidate Description</TableCell>
                          <TableCell>
                            {candidate.candidateDescription}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Total Years of Experience</TableCell>
                          <TableCell>
                            {candidate.totalYearsOfExperience}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            sx={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            Company
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={2}>
                            {candidate.company.map((company, idx) => (
                              <Box key={idx} mb={1}>
                                <strong>{company.name}</strong> <br />
                                Duration: {company.duration} <br />
                                Description: {company.description}
                              </Box>
                            ))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Skills</TableCell>
                          <TableCell>{candidate.skills.join(", ")}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Expertise</TableCell>
                          <TableCell>
                            {candidate.expertise.join(", ")}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DummyForm;
